
import { DnCookiebar } from '@digitalnatives/cookie-consent';

export default {
    components: {
        DnCookiebar
    },

    data() {
        return {
            isOpen: true
        };
    },

    computed: {
        isCookiebarHidden() {
            if (!this.isCookieModalOpen) {
                return true;
            }

            return this.$cookieConsent.isCookiebarDismissed() && !this.isSaving;
        },

        isCookieModalOpen() {
            return this.isOpen;
        }
    }

};
